module.exports = __webpack_public_path__ + "static/img/indicator_light01.fe649d4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/indicator_light01.gif
// module id = K24P
// module chunks = 1